module.exports = __webpack_public_path__ + "img/noGroupOrder.e49575fd.png";